(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-store-locator"] && !Shopify.designMode) return;
  try {
    
  class NativeStoreLocator extends HTMLElement {
    connectedCallback() {
      this.search = this.querySelector('[data-locator-search]');
      this.count = this.querySelector('[data-locator-count]');
      this.empty = this.querySelector('[data-locator-empty]');
      this.grid = this.querySelector('[data-locator-grid]');
      this.cards = Array.from(this.querySelectorAll('[data-locator-card]'));
      this.filters = Array.from(this.querySelectorAll('[data-locator-filter]'));
      this.activeFilter = 'all';
      this.mapRoot = this.querySelector('[data-locator-map]');
      this.mapCanvas = this.querySelector('[data-locator-map-canvas]');
      this.mapAllButton = this.querySelector('[data-locator-map-all]');
      this.markers = new Map();
      this.mapReady = false;
      this.setupMap();

      this.renderFromData().catch(() => {
        this.prepareExistingCards();
        this.updateTotals();
        this.update();
      });

      this.filters.forEach((button) => {
        button.addEventListener('click', () => {
          this.activeFilter = button.dataset.locatorFilter;
          this.filters.forEach((filter) => filter.classList.toggle('is-active', filter === button));
          this.update();
        });
      });

      if (this.search) {
        this.search.addEventListener('input', () => this.update());
      }

      this.updateTotals();
      this.update();
    }

    async renderFromData() {
      const source = this.dataset.locatorSource;
      if (!source || !this.grid) {
        this.prepareExistingCards();
        return;
      }

      const response = await fetch(source);
      if (!response.ok) throw new Error('Store locator data unavailable');

      const locations = await response.json();
      const cards = locations
        .slice()
        .sort((first, second) => this.getRank(first) - this.getRank(second) || first.name.localeCompare(second.name))
        .map((location) => this.createCard(location));

      this.grid.replaceChildren(...cards);
      this.cards = cards;
      this.updateTotals();
      this.update();
    }

    prepareExistingCards() {
      this.cards
        .sort((first, second) => this.getRank(first) - this.getRank(second) || first.querySelector('h2').textContent.localeCompare(second.querySelector('h2').textContent))
        .forEach((card) => {
          this.addPlaceLabel(card);
          this.addCoordinates(card);
          this.grid.appendChild(card);
        });
    }

    createCard(location) {
      const card = document.createElement('article');
      card.className = 'native-store-locator__card';
      card.dataset.locatorCard = '';
      card.dataset.city = location.city || '';
      card.dataset.state = location.state || '';
      card.dataset.lat = location.latitude ? String(location.latitude) : '';
      card.dataset.lng = location.longitude ? String(location.longitude) : '';
      card.dataset.search = [
        location.name,
        location.address1,
        location.address2,
        location.city,
        location.state,
        location.postalCode,
        location.phone,
        this.websiteLabel(location.website)
      ].filter(Boolean).join(' ');

      const content = document.createElement('div');
      const label = document.createElement('span');
      const heading = document.createElement('h2');
      const address = document.createElement('p');
      const details = document.createElement('div');
      const links = document.createElement('div');

      label.className = 'native-store-locator__place';
      label.textContent = `${location.city}, ${this.formatState(location.state)}`;

      heading.textContent = location.name;
      address.append(document.createTextNode(location.address1 || ''));
      if (location.address2) {
        address.append(document.createElement('br'), document.createTextNode(location.address2));
      }
      address.append(document.createElement('br'), document.createTextNode(`${location.city}, ${location.state} ${location.postalCode}`));

      details.className = 'native-store-locator__details';
      if (location.phone) {
        const phone = document.createElement('span');
        phone.textContent = location.phone;
        details.append(phone);
      }
      if (location.website) {
        const website = document.createElement('span');
        website.textContent = this.websiteLabel(location.website);
        details.append(website);
      }

      links.className = 'native-store-locator__links';
      if (location.phone) {
        links.append(this.createLink('Call', `tel:${this.phoneHref(location.phone)}`));
      }
      if (location.website) {
        links.append(this.createLink('Website', location.website, true));
      }
      links.append(this.createLink('Directions', this.directionsHref(location), true));

      content.append(label, heading, address);
      if (details.childElementCount) content.append(details);
      card.append(content, links);

      return card;
    }

    createLink(label, href, opensNewTab = false) {
      const link = document.createElement('a');
      link.href = href;
      link.textContent = label;
      if (opensNewTab) {
        link.target = '_blank';
        link.rel = 'noopener';
      }
      return link;
    }

    directionsHref(location) {
      if (location.latitude && location.longitude) {
        return `https://www.google.com/maps/dir/?api=1&destination=${location.latitude},${location.longitude}`;
      }

      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent([location.name, location.address1, location.city, location.state, location.postalCode].filter(Boolean).join(' '))}`;
    }

    phoneHref(phone) {
      const digits = phone.replace(/\D/g, '');
      return digits.length === 10 ? `+1${digits}` : `+${digits}`;
    }

    websiteLabel(website) {
      if (!website) return '';

      try {
        return new URL(website).hostname.replace(/^www\./, '');
      } catch (error) {
        return website;
      }
    }

    update() {
      const query = this.search ? this.search.value.trim().toLowerCase() : '';
      let visible = 0;

      this.cards.forEach((card) => {
        const matchesQuery = !query || card.dataset.search.toLowerCase().includes(query);
        const matchesFilter = this.matchesFilter(card);
        const shouldShow = matchesQuery && matchesFilter;
        card.hidden = !shouldShow;
        if (shouldShow) visible += 1;
      });

      if (this.count) {
        const label = visible === 1 ? 'store' : 'stores';
        this.count.textContent = `${visible} ${label} shown`;
      }

      if (this.empty) {
        this.empty.hidden = visible !== 0;
      }

      this.syncMap();
    }

    /* ---- map: Leaflet (theme asset) + OpenStreetMap tiles. Loads once the page is idle, or
       as soon as the map nears the viewport, whichever comes first. ---- */
    setupMap() {
      if (!this.mapRoot || !this.mapCanvas) return;
      if (!('IntersectionObserver' in window)) {
        this.mapRoot.hidden = true;
        return;
      }

      if (this.mapAllButton) {
        this.mapAllButton.addEventListener('click', () => this.fitCards(this.cards, true));
      }

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        this.startMap();
      }, { rootMargin: '200px 0px' });
      observer.observe(this.mapRoot);

      const whenIdle = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 1200));
      whenIdle(() => this.startMap());
    }

    startMap() {
      if (this.mapStarted) return;
      this.mapStarted = true;
      this.loadLeaflet()
        .then(() => this.initMap())
        .catch(() => {
          this.mapRoot.hidden = true;
        });
    }

    loadLeaflet() {
      if (window.L && window.L.map) return Promise.resolve();
      if (window.__pafLeafletLoading) return window.__pafLeafletLoading;

      window.__pafLeafletLoading = new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = this.dataset.leafletCss;
        document.head.appendChild(link);

        const script = document.createElement('script');
        script.src = this.dataset.leafletJs;
        script.onload = () => (window.L && window.L.map ? resolve() : reject(new Error('Leaflet missing')));
        script.onerror = () => reject(new Error('Leaflet failed to load'));
        document.head.appendChild(script);
      });

      return window.__pafLeafletLoading;
    }

    initMap() {
      const L = window.L;
      this.mapCanvas.replaceChildren();
      this.map = L.map(this.mapCanvas, { scrollWheelZoom: false, worldCopyJump: true });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.map);
      this.markerLayer = L.layerGroup().addTo(this.map);
      this.mapReady = true;
      this.buildMarkers();
      this.syncMap();
    }

    addCoordinates(card) {
      if (card.dataset.lat && card.dataset.lng) return;
      const directions = card.querySelector('a[href*="destination="]');
      const match = directions && directions.href.match(/destination=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
      if (!match) return;
      card.dataset.lat = match[1];
      card.dataset.lng = match[2];
    }

    buildMarkers() {
      const L = window.L;
      this.markers = new Map();
      const icon = L.divIcon({
        className: 'native-store-locator__pin',
        html: '<span></span>',
        iconSize: [18, 18],
        iconAnchor: [9, 9],
        popupAnchor: [0, -10]
      });

      this.cards.forEach((card) => {
        this.addCoordinates(card);
        const lat = parseFloat(card.dataset.lat);
        const lng = parseFloat(card.dataset.lng);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

        const marker = L.marker([lat, lng], { icon, title: card.querySelector('h2')?.textContent || '' });
        marker.bindPopup(this.popupFor(card), { maxWidth: 260 });
        marker.on('click', () => this.focusCard(card));
        this.markers.set(card, marker);
      });
    }

    popupFor(card) {
      const wrapper = document.createElement('div');
      const name = document.createElement('strong');
      name.textContent = card.querySelector('h2')?.textContent || '';
      wrapper.append(name);

      const address = card.querySelector('p');
      if (address) wrapper.append(address.cloneNode(true));

      const directions = card.querySelector('a[href*="google.com/maps"]');
      if (directions) {
        wrapper.append(document.createElement('br'));
        const link = directions.cloneNode(true);
        link.textContent = 'Directions';
        wrapper.append(link);
      }
      return wrapper;
    }

    syncMap() {
      if (!this.mapReady) return;
      this.markerLayer.clearLayers();
      const visible = this.cards.filter((card) => !card.hidden && this.markers.has(card));
      visible.forEach((card) => this.markers.get(card).addTo(this.markerLayer));

      const query = this.search ? this.search.value.trim() : '';
      const showingEverything = this.activeFilter === 'all' && !query;
      if (this.mapAllButton) this.mapAllButton.hidden = !showingEverything;

      if (showingEverything) {
        const nearby = visible.filter((card) => this.matchesNamedFilter(card, 'pnw'));
        this.fitCards(nearby.length ? nearby : visible);
      } else {
        this.fitCards(visible);
      }
    }

    fitCards(cards, animate = false) {
      if (!this.mapReady) return;
      const points = cards
        .filter((card) => this.markers.has(card))
        .map((card) => this.markers.get(card).getLatLng());
      if (!points.length) return;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.map.fitBounds(window.L.latLngBounds(points), {
        padding: [28, 28],
        maxZoom: 12,
        animate: animate && !reduced
      });
    }

    focusCard(card) {
      this.cards.forEach((other) => other.classList.toggle('is-focused', other === card));
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      card.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      window.clearTimeout(this.focusTimer);
      this.focusTimer = window.setTimeout(() => card.classList.remove('is-focused'), 2800);
    }

    updateTotals() {
      const filters = ['all', 'portland', 'oregon', 'pnw', 'beyond'];

      filters.forEach((filter) => {
        const total = this.cards.filter((card) => this.matchesNamedFilter(card, filter)).length;

        this.querySelectorAll(`[data-locator-filter-total="${filter}"], [data-locator-summary-total="${filter}"]`)
          .forEach((node) => {
            node.textContent = total;
          });
      });
    }

    addPlaceLabel(card) {
      const content = card.querySelector('div');
      if (!content || content.querySelector('.native-store-locator__place')) return;

      const city = card.dataset.city || '';
      const state = card.dataset.state || '';
      const label = document.createElement('span');
      label.className = 'native-store-locator__place';
      label.textContent = `${city}, ${this.formatState(state)}`;
      content.prepend(label);
    }

    getRank(item) {
      const city = (item.city || item.dataset.city || '').toLowerCase();
      const state = (item.state || item.dataset.state || '').toLowerCase();

      if (city === 'portland') return 0;
      if (['beaverton', 'happy valley', 'lake oswego', 'tualatin', 'vancouver'].includes(city)) return 1;
      if (state === 'or' || state === 'oregon') return 2;
      if (state === 'wa' || state === 'id') return 3;
      return 4;
    }

    formatState(state) {
      if (state === 'OR') return 'Oregon';
      if (state === 'WA') return 'Washington';
      if (state === 'ID') return 'Idaho';
      if (state === 'CA') return 'California';
      return state;
    }

    matchesFilter(card) {
      return this.matchesNamedFilter(card, this.activeFilter);
    }

    matchesNamedFilter(card, filter) {
      const city = (card.dataset.city || '').toLowerCase();
      const state = (card.dataset.state || '').toLowerCase();

      if (filter === 'portland') {
        return ['portland', 'beaverton', 'hillsboro', 'happy valley', 'lake oswego', 'tualatin', 'vancouver'].includes(city);
      }

      if (filter === 'oregon') {
        return state === 'or' || state === 'oregon';
      }

      if (filter === 'pnw') {
        return state === 'or' || state === 'oregon' || state === 'wa' || state === 'id';
      }

      if (filter === 'beyond') {
        return !(state === 'or' || state === 'oregon' || state === 'wa' || state === 'id');
      }

      return true;
    }
  }

  customElements.define('native-store-locator', NativeStoreLocator);

  } catch(e) { console.error(e); }
})();
})();
